import { Reducer } from '@reduxjs/toolkit'

import { IHICustomer, IHICustomerDetails } from '../interfaces/IHealthInsurance'

import {
  RESET_HI_CUSTOMER,
  SET_HI_CUSTOMER,
  SET_HI_CUSTOMER_DETAILS,
  TActionTypes,
} from './actionTypes'

interface IHealthInsuranceState {
  customer: IHICustomer | null
  customerDetails: IHICustomerDetails | null
  apiResponse: 'success' | null
}

const initialState: IHealthInsuranceState = {
  customer: null,
  customerDetails: null,
  apiResponse: null,
}

export const healthInsuranceReducer: Reducer<
  IHealthInsuranceState,
  TActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SET_HI_CUSTOMER:
      return {
        ...state,
        customer: action.payload.customerData,
      }
    case SET_HI_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetails: action.payload.customerData,
      }
    case RESET_HI_CUSTOMER:
      return {
        ...state,
        customer: null,
        customerDetails: null,
      }
    default:
      return state
  }
}
